<template>
    <el-dialog class="modify-password dialog-w420" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true" @before-close="cancel" :visible.sync="modifyVisible">
        <div class="dialog-title">修改密码</div>
        <input type="text" hidden autocomplete="new-password">
        <div class="input-item">
            <el-input type="password" v-model="oldpwd" maxlength="16" name="pwd" placeholder="请输入旧密码" autocomplete="new-password"/>
        </div>
        <div class="input-item">
            <el-input type="password" v-model="newpwd" maxlength="16" name="pwd" placeholder="请输入新密码" autocomplete="new-password"/>
        </div>
        <div class="input-item">
            <el-input type="password" v-model="confirmpwd" maxlength="16" name="pwd" placeholder="请确认新密码" autocomplete="new-password"/>
        </div>
        <div class="btn-multi">
            <a href class="default" @click.prevent="cancel">取消</a>
            <a href class="primary" @click.prevent="submit">提交</a>
        </div>
    </el-dialog>
</template>
<script>
    import { removeStore} from '@/utils/utils.js'
    import {updatePassword, getPublicKey} from '@/api/login.js'
    import JsEncrypt from 'jsencrypt'
    export default {
        data() {
            return {
                tipText: '',
                modifyVisible: false,
                oldpwd: '',
                newpwd: '',
                confirmpwd: ''
            }
        },
        watch: {
            tipText(value) {
                if (value) {
                    this.$message({
                        type: 'warning',
                        message: value
                    })
                }
                this.tipText = ''
            }
        },
        mounted() {
        },
        methods: {
            cancel() {
                this.modifyVisible = false
                this.oldpwd = ''
                this.newpwd = ''
                this.confirmpwd = ''
            },
            submit() {
                if (!this.oldpwd.trim()) {
                    return this.tipText = '请输入密码'
                }
                if (!this.newpwd.trim()) {
                    return this.tipText = '请输入新密码'
                }
                if (!this.confirmpwd.trim()) {
                    return this.tipText = '请确认新密码'
                }
                if (this.newpwd !== this.confirmpwd) {
                    return this.tipText = '两次输入密码不一致'
                }

                updatePassword({
                    oldPassword: this.oldpwd,
                    newPassword: this.newpwd,
                }).then(res => {
                    if (res.data.code === 1000) {
                        this.$message({
                            type: 'success',
                            message: '密码修改成功，请重新登录'
                        })
                        setTimeout(function() {
                            removeStore('loginUser')
                            removeStore('authToken')
                            removeStore('refreshToken')
                            window.location.href = '/loginWorker'
                        }, 2000)
                    } else {
                        this.$message.error(res.data.message)
                    }
                }, err => {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }) 
            },
        },
    }
</script>
<style lang="scss">
    
</style>
